import { basePath, apiVersion } from './config';

export async function getServicesApi(tenantId) {
  const url = `${basePath}/${apiVersion}/services-portal?tenant=${tenantId}`;

  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}
